import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.string.trim.js";
import dsteem from "../unit/DsteemUtil";
import { toDecimal } from "../unit/public";
import { getAccount, extractLoginData } from "../unit/UserUtil";
export default {
  name: "Login",
  props: ["isShowModelAdvancedSetting", "modelValue"],
  emits: ["update:modelValue", "update:isShowModel"],
  data: function data() {
    return {
      showLoginModel: false,
      beneficiarieList: [],
      isLoginError: false
    };
  },
  watch: {
    isShowModelAdvancedSetting: function isShowModelAdvancedSetting(newVal) {
      this.showLoginModel = newVal;
    },
    modelValue: function modelValue(newVal) {
      this.beneficiarieList = newVal;
    },
    showLoginModel: function showLoginModel(newVal) {
      this.$emit("update:isShowModelAdvancedSetting", newVal);
    }
  },
  methods: {
    editModelValue: function editModelValue() {
      var self = this.beneficiarieList[0];
      self.percentage = 100;
      this.beneficiarieList.forEach(function (value) {
        if (self.id != value.id) self.percentage -= value.percentage;
      });

      if (self.percentage < 0) {
        self.percentage = 0;
      }

      this.beneficiarieList[0] = self;
    },
    addBeneficiar: function addBeneficiar() {
      var maxObject = this.beneficiarieList.reduce(function (prev, current) {
        return prev.id > current.id ? prev : current;
      });
      var beneficiarie = {
        id: maxObject.id + 1,
        percentage: 0,
        useranme: ""
      };
      this.beneficiarieList.push(beneficiarie);
    },
    removeBeneficiar: function removeBeneficiar(obj) {
      var indexToRemove = this.beneficiarieList.indexOf(obj);

      if (indexToRemove !== -1) {
        this.beneficiarieList.splice(indexToRemove, 1);
      }

      this.editModelValue();
    },
    comfirm: function comfirm() {
      var percentage = 0;
      var isHaveNullUser = false;
      this.beneficiarieList.forEach(function (value) {
        percentage += value.percentage;

        if (value.useranme.trim() == "") {
          isHaveNullUser = true;
        }
      });

      if (isHaveNullUser) {
        this.errorMessage = "haveNullUser";
        this.isLoginError = true;
        return;
      }

      if (percentage != 100) {
        this.errorMessage = "wrongPercentage";
        this.isLoginError = true;
        return;
      } else {
        this.isLoginError = false;
      }

      this.$emit("update:modelValue", this.beneficiarieList);
      this.$emit("saveAdvancedSettings");
      this.showLoginModel = false;
    },
    cancel: function cancel() {
      this.beneficiarieList = [];

      if (localStorage.getItem("beneficiarieList") && localStorage.getItem("beneficiarieList") != "undefined") {
        this.beneficiarieList = JSON.parse(localStorage.getItem("beneficiarieList"));
      } else {
        var beneficiarie = {
          id: 0,
          percentage: 100,
          useranme: this.loginData[0]
        };
        this.beneficiarieList.push(beneficiarie);
      }

      this.$emit("update:modelValue", this.beneficiarieList);
      this.showLoginModel = false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.beneficiarieList = _this.modelValue;
              _this.loginData = extractLoginData();

              if (_this.loginData) {
                _this.fromUser = _this.loginData[0];
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};